"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _InnerHtml = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/InnerHtml"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Text = (0, _styled["default"])(_InnerHtml["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    overflow: auto;\n    padding: 0 0.6rem;\n    border: 1px solid transparent;\n    max-width: ", ";\n    margin: ", ";\n\n    > :first-child {\n        margin-top: 1.5rem;\n    }\n\n    > :last-child {\n        margin-bottom: 1.5rem;\n    }\n\n    figure.table {\n        overflow-y: visible;\n        overflow-x: scroll;\n\n        td {\n            padding-left: 10px;\n            padding-right: 10px;\n        }\n    }\n"])), function (props) {
  return "".concat(props.maxwidth, "%");
}, function (props) {
  switch (props.blockalignment) {
    case 'center':
      return "0 auto";

    case 'right':
      return "0 0 0 auto";

    default:
      return "".concat(function (props) {
        return props.maxwidth < 100 ? "0 auto 0 0" : "0 auto";
      });
  }
});

var TextRenderer = function TextRenderer(_ref) {
  var _ref$state = _ref.state,
      text = _ref$state.text,
      _ref$state$maxWidth = _ref$state.maxWidth,
      maxWidth = _ref$state$maxWidth === void 0 ? 100 : _ref$state$maxWidth,
      _ref$state$blockAlign = _ref$state.blockAlignment,
      blockAlignment = _ref$state$blockAlign === void 0 ? 'left' : _ref$state$blockAlign;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    content: text,
    maxwidth: maxWidth,
    blockalignment: blockAlignment,
    className: "content__text"
  });
};

var _default = TextRenderer;
exports["default"] = _default;